import { lazy } from 'react'
import yn from 'yn'

const fallback = null

const features = Object.freeze({
  CategoriesHighlightShowcase: yn(
    process.env.REACT_APP_HAS_CATEGORIES_HIGHLIGHT_SHOWCASE)
    ? lazy(() => import('Catalog/Showcase/CategoriesHighlightShowcase'))
    : fallback,
  RedirectCustomConexxeFeature: yn(
    process.env.REACT_APP_CONEXXE_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectConexxe/RedirectConexxe'))
    : fallback,
  RedirectCustomZendeskFeature: yn(
    process.env.REACT_APP_ZENDESK_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectZendesk/RedirectZendesk'))
    : fallback,
  RedirectCustomContactZendeskFeature: yn(
    process.env.REACT_APP_ZENDESK_TOGGLE_REDIRECT
  )
    ? lazy(() => import('../RedirectCustom/RedirectZendesk/RedirectContactZendesk'))
    : fallback,
  ZendeskWebWidget: yn(process.env.REACT_APP_HAS_ZENDESK_WEBWIDGET)
    ? lazy(() => import('Widgets/Zendesk'))
    : fallback,
  SalesForceWebWidget: yn(process.env.REACT_APP_HAS_CHATBOT_SALESFORCE)
    ? lazy(() => import('Widgets/SalesForce'))
    : fallback,
  TagManagerWidget: lazy(() => import('Widgets/TagManagerWidget')),
  CupomFeature: yn(process.env.REACT_APP_COUPON_DISCOUNT)
    ? lazy(() => import('features/Checkout/Summary/Coupon/Coupon'))
    : fallback,
  TourGuide: yn(process.env.REACT_APP_TOUR_GUIDE)
    ? lazy(() => import('App/TourGuide/TourHomePage'))
    : fallback,
  CashBackBF: yn(process.env.REACT_APP_HAS_CASHBACK_BF)
    ? lazy(() => import('Catalog/Availability/CashBackBF'))
    : fallback,
  CashBackBonus: yn(process.env.REACT_APP_HAS_CASHBACK_BF)
    ? lazy(() => import('Catalog/Availability/CashBackBonus'))
    : fallback,
  BannerCashBack: yn(process.env.REACT_APP_LADDING_CASHBACK)
    ? lazy(() => import('features/BannerCashback/BannerCashback'))
    : fallback,
  LGPDAlert: yn(process.env.REACT_APP_LGPD_CONSENT)
    ? lazy(() => import('App/Shell/LGPDAlert'))
    : fallback,
  HeaderFeature: process.env.REACT_APP_HEADER_COMPONENT
    ? lazy(() => import(`App/Header/${process.env.REACT_APP_HEADER_COMPONENT}`))
    : lazy(() => import('App/Header/DefaultHeader')),
  headerMileage: process.env.REACT_APP_HEADER_MILEAGE
    ? lazy(() => import(`features/MileageRescue/mileageHeaderIupp`))
    : lazy(() => import('features/MileageRescue/mileageHeader')),
  SearchFeature: process.env.REACT_APP_SEARCH_COMPONENT
    ? lazy(() => import(`App/Header/Search/${process.env.REACT_APP_SEARCH_COMPONENT}`))
    : lazy(() => import('App/Header/Search/Search')),
  UserProfileFeature: process.env.REACT_APP_USER_PROFILE_COMPONENT
    ? lazy(() => import(`App/Header/UserProfile/${process.env.REACT_APP_USER_PROFILE_COMPONENT}`))
    : lazy(() => import('App/Header/UserProfile/UserProfile')),
  HelperChat: process.env.REACT_APP_CHAT_URL && process.env.REACT_APP_CHAT_ID
    ? lazy(() => import('features/Faq/HelperChat'))
    : fallback,
  SideChat: process.env.REACT_APP_CHAT_URL && process.env.REACT_APP_CHAT_ID
    ? lazy(() => import('features/Contact/SideChat'))
    : fallback,
  MileageHowToUse: yn(process.env.REACT_APP_FUELCREDIT_HOWTOUSE)
    ? lazy(() => import('features/FuelCredit/HowToUse'))
    : fallback,
  ForceUpgradeInsecureRequests: yn(process.env.REACT_APP_FORCE_UPGRADE_INSECURE_REQUESTS)
    ? lazy(() => import('App/Shell/ForceUpgradeInsecureRequests'))
    : fallback,
  ConnexeBanner: yn(
    process.env.REACT_APP_HAS_CONNEXXE_BANNER
  )
    ? lazy(() => import('features/Slider/ConexxeBanner'))
    : fallback,
  CategoriesShowcase: yn(
    process.env.REACT_APP_HAS_CATEGORIES_SHOWCASE
  )
    ? lazy(() => import('Catalog/Showcase/CategoriesShowcase'))
    : fallback,
  FilteredShowcase: yn(
    process.env.REACT_APP_HAS_FILTERED_SHOWCASE
  )
    ? lazy(() => import('Catalog/Showcase/FilteredShowcase'))
    : fallback,
  BestOffers: yn(
    process.env.REACT_APP_HAS_BEST_OFFERS
  )
    ? lazy(() => import(process.env.REACT_APP_HAS_BEST_OFFERS_CUSTOM))
    : fallback,
  AccumulatePoinstBanner: yn(
    process.env.REACT_APP_HAS_ACCUMULATE_BANNERS
  )
    ? lazy(() => import('features/AccumulatePoints/AccumulatePoints'))
    : fallback,
  BenefitsShowcase: yn(
    process.env.REACT_APP_HAS_BENEFITS_SHOWCASE
  )
    ? lazy(() => import('Catalog/Showcase/BenefitsShowcase'))
    : fallback,
  ConnexeBannerDFP: yn(
    process.env.REACT_APP_HAS_CONNEXXE_BANNER_DFP
  )
    ? lazy(() => import('features/Slider/ConexxeBannerDFP'))
    : fallback,
  StoreSuggestion: yn(
    process.env.REACT_APP_HAS_STORES_SHOWCASE
  )
    ? lazy(() => import('features/Suggestion/StoreSuggestion/StoreSuggestion'))
    : fallback,
  BannersVSA: yn(
    process.env.REACT_APP_BANNERS_VSA
  )
    ? lazy(() => import('features/Services/BannersVSA/BannersVSA'))
    : fallback,
  HistoryExtract: yn(
    process.env.REACT_APP_HAS_HISTORY_EXTRACT
  )
    ? lazy(() => import('Participant/Extract/Totalizers/History'))
    : fallback,
  TradeMenuHome: yn(
    process.env.REACT_APP_HAS_TRADEMENU_HOME
  )
    ? lazy(() => import('App/MainMenu/MenuMobile/MenuHomeContainer'))
    : fallback,
  tradeMenu: process.env.REACT_APP_TRADEMENU_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_TRADEMENU_CUSTOM))
    : lazy(() => import('App/MainMenu/MenuMobile/MenuHome')),
  AlertMessage: yn(
    process.env.REACT_APP_HAS_ALERT_MESSAGE
  )
    ? lazy(() => import('App/Header/AlertMessage'))
    : fallback,
  RegulationComponent:
    process.env.REACT_APP_HAS_REGULATION_CUSTOM
      ? lazy(() => import(`features/Regulation/${process.env.REACT_APP_HAS_REGULATION_CUSTOM}`))
      : lazy(() => import('features/Regulation/RegulationDefault')),
  PrivacyComponent:
      process.env.REACT_APP_HAS_PRIVACY_CUSTOM
        ? lazy(() => import(`features/Privacy/${process.env.REACT_APP_HAS_PRIVACY_CUSTOM}`))
        : lazy(() => import('features/Privacy/PrivacyDefault')),
  TermsComponent:
      process.env.REACT_APP_HAS_TERMS_CUSTOM
        ? lazy(() => import(`features/Terms/${process.env.REACT_APP_HAS_TERMS_CUSTOM}`))
        : lazy(() => import('features/Terms/TermsDefault')),
  Showcase:
      process.env.REACT_APP_HAS_VOUCHER_SHOWCASE
        ? lazy(() => import('Catalog/Showcase/ShowcaseContainer'))
        : fallback,
  MileageAreaHome:
      yn(process.env.REACT_APP_DISABLE_MILEAGE_AREA_HOME)
        ? fallback
        : lazy(() => import('features/Services/Mileage/Mileage')),
  ServicesContainer: !yn(process.env.REACT_APP_DISABLE_SERVICES_AREA_HOME)
    ? lazy(() => import('features/Services/Services'))
    : fallback,
  RechargePhoneService: lazy(() => import('features/Services/RechargePhone/RechargePhone')),
  BillPaymentService: lazy(() => import('features/Services/BillPayment/BillPayment')),
  FuelCreditService: lazy(() => import('features/Services/FuelCredit/FuelCredit')),
  TourGuideModal: process.env.REACT_APP_TOUR_GUIDE_MODAL_COMPONENT
    ? lazy(() => import(process.env.REACT_APP_TOUR_GUIDE_MODAL_COMPONENT))
    : lazy(() => import('App/TourGuide/Modal/TourGuideModal')),
  TourGuideSteps: process.env.REACT_APP_TOUR_GUIDE_STEPS_COMPONENT
    ? lazy(() => import(process.env.REACT_APP_TOUR_GUIDE_STEPS_COMPONENT))
    : lazy(() => import('App/TourGuide/Steps/TourGuideSteps')),
  NpsGoogleForms: process.env.REACT_APP_NPS_GFORMS_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_NPS_GFORMS_CUSTOM))
    : lazy(() => import('features/Nps/GoogleForms')),
  PointsAndCash: process.env.REACT_APP_POINTSANDCASH_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_POINTSANDCASH_CUSTOM))
    : lazy(() => import('features/PointsAndCash/DefaultPointsAndCash')),
  AccessibilityStatus: process.env.REACT_APP_ACCESSIBILITY_STATUS_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_ACCESSIBILITY_STATUS_CUSTOM))
    : lazy(() => import('features/Accessibility/AccessibilityDefault')),
  HeadMetaData: process.env.REACT_APP_HEAD_METADATA_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_HEAD_METADATA_CUSTOM))
    : lazy(() => import('Shared/HeadMetadata/HeadMetadata')),
  footerContent: process.env.REACT_APP_FOOTER_CONTENT_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_FOOTER_CONTENT_CUSTOM))
    : lazy(() => import('App/Footer/Custom/FooterContent')),
  HeaderDisconnected: yn(process.env.REACT_APP_HEADERIUPP) && process.env.REACT_APP_HEADERIUPP_COMPONENT
    ? lazy(() => import(process.env.REACT_APP_HEADERIUPP_COMPONENT))
    : lazy(() => import('App/Header/GuestHeader/GuestHeader')),
  CategoryGroup: process.env.REACT_APP_CATEGORYGROUP_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_CATEGORYGROUP_CUSTOM))
    : fallback,
  StoreGroup: process.env.REACT_APP_STOREGROUP_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_STOREGROUP_CUSTOM))
    : fallback,
  StoreServiceGroup: process.env.REACT_APP_STORESERVICEGROUP_CUSTOM
    ? lazy(() => import(process.env.REACT_APP_STORESERVICEGROUP_CUSTOM))
    : fallback,
  BillpaymentCustomTerms: process.env.REACT_APP_BILLPAYMENT_CUSTOM_TERMS
    ? lazy(() => import(process.env.REACT_APP_BILLPAYMENT_CUSTOM_TERMS))
    : lazy(() => import('features/BillPayment/BillPaymentTerm/DefaultTerms')),
  PhraseExtract: process.env.REACT_APP_PHRASE_EXTRACT
    ? lazy(() => import(process.env.REACT_APP_PHRASE_EXTRACT))
    : lazy(() => import('Participant/Extract/Details/PhraseExtract')),
  LikePlusFaq: process.env.REACT_APP_LIKEPLUS_FAQ
    ? lazy(() => import(process.env.REACT_APP_LIKEPLUS_FAQ))
    : lazy(() => import('features/LikePlus/Tabs/Help/Help')),
  LikePlusHelpAside: process.env.REACT_APP_LIKEPLUS_HELP_ASIDE
    ? lazy(() => import(process.env.REACT_APP_LIKEPLUS_HELP_ASIDE))
    : lazy(() => import('features/LikePlus/Tabs/Help/HelpAside')),
  LikePlusModalRegulation: process.env.REACT_APP_LIKEPLUS_REGULATION
    ? lazy(() => import(process.env.REACT_APP_LIKEPLUS_REGULATION))
    : lazy(() => import('features/LikePlus/Tabs/Regulation/ModalRegulation')),
  LikePlusDeliveryDetail: process.env.REACT_APP_DELIVERY_DETAIL
    ? lazy(() => import(process.env.REACT_APP_DELIVERY_DETAIL))
    : lazy(() => import('features/LikePlus/Tabs/RequestCard/Address/DeliveryDetails/Default')),
  SSORedirect: yn(process.env.REACT_APP_SSO_REDIRECT)
    ? lazy(() => import('Widgets/SimpleRedirect'))
    : lazy(() => import('App/FourOFour')),
  LoadingSplash: process.env.REACT_APP_LOADING_SPLASH
    ? lazy(() => import(process.env.REACT_APP_LOADING_SPLASH))
    : lazy(() => import('App/SplashScreen/ContentSplashDefault')),
  ShoppingAuthenticate: yn(
    process.env.REACT_APP_HAS_SHOPPING_REDIRECT
  )
    ? lazy(() => import('Widgets/ShoppingAuthenticate'))
    : lazy(() => import('App/FourOFour'))
})

export default features



// WEBPACK FOOTER //
// ./src/features/ToggleFeature/Features.js